import React from 'react';
import {
	colors,
	ApSimpleDropdown,
	ApButtonIcon,
} from '@alixpartners/ui-components';

import { Breadcrumbs } from 'Details/Breadcrumbs';

import {
	Wrapper,
	ToggleWrapper,
	Title,
	ContentHeader,
	LayoutRow,
	Separator,
	CheckboxLabel,
	Checkbox,
} from './styles';
import { CHART_TYPES } from 'Details/DetailsChart/DetailsChart';

const CHART_TYPE_OPTIONS = {
	[CHART_TYPES.waterfall]: {
		label: 'Waterfall',
		value: 'waterfall',
	},
	[CHART_TYPES.bar]: {
		label: 'Stacked column',
		value: 'bar',
	},
};

const exportOptions = [
	{
		label: 'Export as image',
		value: 'png',
	},
	{
		label: 'Export as data',
		value: 'xls',
	},
];

const ICONS_MAP = {
	[CHART_TYPES.waterfall]: 'waterfall_chart',
	[CHART_TYPES.line]: 'line_chart',
	[CHART_TYPES.bar]: 'column_chart',
	[CHART_TYPES.scatter]: 'scatter_chart',
	[CHART_TYPES.stackedBar]: 'stacked_column_chart',
	[CHART_TYPES.stackedBar100]: 'stacked_100_column_chart',
};

export const HeroChartOptions = props => {
	const [isExpanded, setExpanded] = React.useState(true);

	const {
		chartType: chartTypeProp,
		onChange,
		onPngExportClick,
		onXlsExportClick,
		onBreadcrumbsClick,
		breadcurmbsOptions,
		showAllCategories,
		allowShowAllCategories,
		showAllSegments,
		allowShowTailSpend,
		showTailSpend,
		noData,
	} = props;

	const chartTypeOptions = [
		CHART_TYPE_OPTIONS.waterfall,
		CHART_TYPE_OPTIONS.bar,
	];

	const chartType =
		showAllSegments && chartTypeProp === CHART_TYPES.waterfall
			? CHART_TYPES.bar
			: chartTypeProp;

	const selectedChartTypeOption = chartTypeOptions.find(
		option => option.value === chartType
	);

	const handleChartTypeChange = selectedItem => {
		onChange({ chartType: selectedItem.value });
	};

	const handleExpandToggle = () => {
		setExpanded(!isExpanded);
	};

	const handleShowAllCategories = () => {
		onChange({ showAllCategories: !showAllCategories });
	};

	const handleShowTailSpend = () => {
		onChange({ showTailSpend: !showTailSpend });
	};

	const handleExportSelect = selectedItem => {
		if (selectedItem.value === 'png') {
			onPngExportClick && onPngExportClick();
		}

		if (selectedItem.value === 'xls') {
			onXlsExportClick && onXlsExportClick();
		}
	};

	if (noData) {
		return (
			<Wrapper expanded={false}>
				<LayoutRow>
					<ContentHeader>
						<Breadcrumbs
							options={breadcurmbsOptions}
							onClick={onBreadcrumbsClick}
						/>
					</ContentHeader>
				</LayoutRow>
			</Wrapper>
		);
	}

	return (
		<Wrapper expanded={isExpanded}>
			<LayoutRow>
				<ContentHeader>
					<Breadcrumbs
						options={breadcurmbsOptions}
						onClick={onBreadcrumbsClick}
					/>
				</ContentHeader>
				<ToggleWrapper>
					<ApButtonIcon
						iconName="baseline_tune"
						iconProps={{ iconColor: colors.grey8 }}
						onClick={handleExpandToggle}
					/>
					<Title>{`${isExpanded ? 'Hide' : 'Show'} options`}</Title>
				</ToggleWrapper>
			</LayoutRow>
			<LayoutRow>
				<ApSimpleDropdown
					options={chartTypeOptions}
					selected={selectedChartTypeOption}
					onChange={handleChartTypeChange}
					iconName={ICONS_MAP[chartType] || 'line_chart'}
				/>
				<Separator />

				{allowShowAllCategories && (
					<Checkbox
						autoFocus={false}
						disabled={false}
						theme="light"
						type="checkbox"
						checked={showAllCategories}
						onChange={handleShowAllCategories}
					>
						<CheckboxLabel>Show all categories</CheckboxLabel>
					</Checkbox>
				)}
				{allowShowTailSpend && (
					<Checkbox
						autoFocus={false}
						disabled={false}
						theme="light"
						type="checkbox"
						checked={showTailSpend}
						onChange={handleShowTailSpend}
					>
						<CheckboxLabel>Show tail spend</CheckboxLabel>
					</Checkbox>
				)}
				<Separator />
				<ApSimpleDropdown
					options={exportOptions}
					selected={[]}
					label="Export"
					onChange={handleExportSelect}
					iconName="outline_save_alt"
				/>
			</LayoutRow>
		</Wrapper>
	);
};

export default HeroChartOptions;
